import { type ReactNode } from 'react'

import { type ExternalBankAccount } from '@webapp/platform/banking/entities/ExternalBankAccount'
import { useExternalBankAccountConfigListPresenter } from './useExternalBankAccountConfigListPresenter'
import { ExternalBankAccountConfigTable } from '../../views/ExternalBankAccountConfigTable'

export interface IExternalBankAccountConfigListPresenterProps {
  onDeleteAccount: (account: ExternalBankAccount) => void
  actionSlot?: ReactNode
}

export const ExternalBankAccountConfigListPresenter = ({
  onDeleteAccount,
  actionSlot,
}: IExternalBankAccountConfigListPresenterProps) => {
  const {
    data: { accounts },
    states: { isFetching, isError },
  } = useExternalBankAccountConfigListPresenter()

  return (
    <ExternalBankAccountConfigTable
      accounts={accounts}
      isLoading={isFetching}
      isError={isError}
      onDeleteAccount={onDeleteAccount}
      actionSlot={actionSlot}
    />
  )
}

ExternalBankAccountConfigListPresenter.displayName =
  'ExternalBankAccountConfigListPresenter'
